
import { DayOfWeek } from '@/models/Schedule';
import { TimeSlotFormData } from '../timeSlotFormSchema';

export const createRegularTimeSlots = (data: TimeSlotFormData) => {
  return data.selectedDays.map((day) => ({
    day_of_week: day,
    start_time: data.startTime,
    end_time: data.endTime,
    workout_type_id: data.workoutTypeId,
    max_clients: data.maxClients,
    is_active: true,
  }));
};

export const validateOverlaps = (
  data: TimeSlotFormData,
  checkForOverlaps: (
    day: DayOfWeek,
    startTime: string,
    endTime: string,
    workoutTypeId: string
  ) => boolean
): string[] => {
  const overlappingDays: string[] = [];
  
  data.selectedDays.forEach((day) => {
    if (
      checkForOverlaps(
        day as DayOfWeek,
        data.startTime!,
        data.endTime!,
        data.workoutTypeId
      )
    ) {
      overlappingDays.push(day);
    }
  });

  return overlappingDays;
};
